export default __webpack_public_path__ + "static/media/simbolo_cozinha.24cb4f25.svg";